import { call, put, takeLatest } from "redux-saga/effects";
import { GET_PerformanceTeam, GET_PerformanceReport, POST_PerformanceSnapshot } from "../services/Performance";
import exception from "../utils/exception";
import { jwtDecode, jwtEncode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_PerformanceTeamEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_PerformanceTeam, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_PerformanceTeam", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_PerformanceReportEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_PerformanceReport, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_PerformanceReport", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_PerformanceTeamPrevEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_PerformanceTeam, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_PerformanceTeamPrev", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_PerformanceSnapshotEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(POST_PerformanceSnapshot, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* PerformanceSaga() {
  yield takeLatest("GET_PerformanceTeam", GET_PerformanceTeamEffect);
  yield takeLatest("GET_PerformanceTeamPrev", GET_PerformanceTeamPrevEffect);
  yield takeLatest("GET_PerformanceReport", GET_PerformanceReportEffect);
  yield takeLatest("POST_PerformanceSnapshot", POST_PerformanceSnapshotEffect);
}
